import { FormErrorMessage as BaseFormErrorMessage } from "@chakra-ui/react";

export default BaseFormErrorMessage;
